import { colors } from '../utils/constants';

// Chart color scheme
export const CHART_COLORS = {
  TOTAL: colors.blue,
  INCREASE: '#10B981',
  DECREASE: '#EF4444',
  GRID: '#E5E7EB',
  TEXT: '#6B7280',
  REFERENCE_LINE: '#9CA3AF'
};

// Return categories in display order
export const RETURN_CATEGORIES = ['equity', 'efficiency', 'income', 'contract'];

// Return category display labels
export const RETURN_LABELS = {
  equity: 'Equity',
  efficiency: 'Efficiency',
  income: 'Income',
  contract: 'Contract',
  total: 'Total'
};

// Chart dimensions
export const CHART_CONFIG = {
  HEIGHT: 384, // h-96 equivalent in pixels
  Y_AXIS_WIDTH: 80,
  TOOLTIP_STYLE: {
    backgroundColor: 'white',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
  }
};

// Format value for Y-axis (millions)
export const formatYAxisValue = (value) => `$${(value / 1000000).toFixed(1)}M`;

// Format currency value (whole numbers with commas)
export const formatCurrencyValue = (value) => `$${Math.round(value).toLocaleString()}`;
